import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import { ROOT_URL } from '../../actions/root_url';
import moment from 'moment';
import { Field } from 'redux-form';
import { DatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import GenericDatePicker from '../Common/GenericDatePicker';

const { Selectors } = Data;

const dataValid = (data) => {
    // if (!data.name || !data.address) {
    //   return;
    // }
    return true
  }

export class GenerateBOLModal extends Component {
    constructor() {
        super();
        this.state = {
            trailer_num: "",
            // load_num: "",
            isa_num: "",
            pro_num: "",
            seal_num: "",
            is_3party: false,
            is_collect: false,
            is_prepaid: false,
            // ship_street: "",
            // ship_city: "",
            // ship_state: "",
            // ship_name: "",
            // ship_zip: "",
            ship_date: null,
        };
        this.setShipDate = this.setShipDate.bind(this);
      }
    
      componentDidMount() {
        //   console.log("st", this.props.salesOrderIdString);
        //   console.log("st", this.props.salesOrderNumString);

        // fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess)
      }
    
      handleInputFieldChange = ({ name, value }) => {
        this.setState({ [name]: value });
      };
      handleInputFieldChangeBool = (field, value) => {
        this.setState({ [field]: value.checked });
      };
        
        // handleFetchCustomerDetailsSuccess = ({ data }) => {
        //   this.setState({
        //     name: "",
        //     address: "",
        //     phone: "",
        //     note: "",
        //     customerDetails: data,
        //   })
        // }
    
      handleSubmit = () => {
    
        if (!dataValid(this.state)) {
          alert(' are required')
          return;
        }
    
        // this.setState({
        //   buttonDisabled: true,
        // })
        // const customerDetails = {
        //   ...this.state.customerDetails
        // }
    
        const data = {
          ...this.state,
        };
      
        // console.log("SUBMIT", data);
        axios({
            method: 'POST',
            data,
            url: `${ROOT_URL}v2/sales/bol/${this.props.salesOrderIdString}/`,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          })
          .then(res => {
              alert("BOL Generated");
              this.props.closeGenerateBOLModal();
            //   this.props.modalFetchFBA();
            }, err => {
              alert("Error generating BOL");  
            })
    
        // addShippingAddress(customerDetails, this.props.receivingCustomer, () => {
        //   this.props.reFetchSalesCustomers();
        //   this.setState({
        //     buttonDisabled: false,
        //   })
        // })
      };

      setShipDate(e) {
        // if (!this.props.Vendor) {
        //   alert('Please select a Vendor!');
        //   return;
        // }
        // if (e > this.state.toDate) {
        //   return;
        // }
        this.setState({ ship_date: e });
      }
    


      render() {
        const { trailer_num,
        // load_num,
        isa_num,
        pro_num,
        seal_num,
        is_3party,
        is_collect,
        is_prepaid,
        // ship_street,
        // ship_city,
        // ship_state,
        // ship_name,
        // ship_zip,
        ship_date,
       } = this.state;

       let testing = true;
        return (
          <div>

<Row>
              <Col sm={12}>
                <label>
                  <Translate value="selected_orders" />:
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
               <p style={{overflowWrap: 'break-word', height: '35px', overflowY: "scroll"}}>{this.props.salesOrderNumString}</p>
              </Col>
            </Row>
{
  testing &&
<div>
            <Row>
              <Col sm={6}>
                <label>
                  <Translate value="trailer_num" />:
                </label>
              </Col>
               <Col sm={6}>
                <label>
                  <Translate value="ship_date" />:
                </label>
              </Col>
              {/* <Col sm={6}>
                <label>
                  <Translate value="load_num" />:
                </label>
              </Col> */}
            </Row>
            <Row>
              <Col sm={6}>
                <Input
                  type="text"
                  name="trailer_num"
                  value={trailer_num}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
              <Col sm={6}>
              
              {
                 GenericDatePicker({
                  setDate: this.setShipDate,
                  selectedDate: this.state.ship_date,
                  onChange: (e) => {
                    this.setShipDate(e);
                  },
                })
              }
                            </Col>
              {/* <Col sm={6}>
                <Field name='ship_date' onChange={(e) => this.setShipDate(e)} selected={this.state.ship_date} component={DatePicker} />
              </Col> */}
              {/* <Col sm={6}>
                <Input
                  type="text"
                  name="load_num"
                  value={load_num}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col> */}
            </Row>
            <Row>
              <Col sm={6}>
                <label>
                  <Translate value="isa_num" />:
                </label>
              </Col>
              <Col sm={6}>
                <label>
                  <Translate value="pro_num" />:
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Input
                  type="text"
                  name="isa_num"
                  value={isa_num}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
              <Col sm={6}>
                <Input
                  type="text"
                  name="pro_num"
                  value={pro_num}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={6}>
                <label>
                  <Translate value="seal_num" />:
                </label>
              </Col>
              <Col sm={2}>
                <label>
                  <Translate value="3rd_party" />:
                </label>
              </Col>
              <Col sm={2}>
                <label>
                  <Translate value="collect" />:
                </label>
              </Col>
              <Col sm={2}>
                <label>
                  <Translate value="prepaid" />:
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Input
                  type="text"
                  name="seal_num"
                  value={seal_num}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
              <Col sm={2}>
              <input type="checkbox" value="true" checked={this.state.is_3party == true || this.state.is_3party == "true"} onClick={(e)=>{this.handleInputFieldChangeBool("is_3party" , e.target)}}/>
              </Col>
              <Col sm={2}>
              <input type="checkbox" value="true" checked={this.state.is_collect == true || this.state.is_collect == "true"} onClick={(e)=>{this.handleInputFieldChangeBool("is_collect" , e.target)}}/>
              </Col>
              <Col sm={2}>
              <input type="checkbox" value="true" checked={this.state.is_prepaid == true || this.state.is_prepaid == "true"} onClick={(e)=>{this.handleInputFieldChangeBool("is_prepaid" , e.target)}}/>
              </Col>
            </Row>

            {/* <Row>
              <Col sm={6}>
                <label>
                  <Translate value="street" />:
                </label>
              </Col>
              <Col sm={6}>
                <label>
                  <Translate value="city" />:
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Input
                  type="text"
                  name="ship_street"
                  value={ship_street}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
              <Col sm={6}>
                <Input
                  type="text"
                  name="ship_city"
                  value={ship_city}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
            </Row> */}

            {/* <Row>
              <Col sm={6}>
                <label>
                  <Translate value="state" />:
                </label>
              </Col>
              <Col sm={6}>
                <label>
                  <Translate value="zip" />:
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Input
                  type="text"
                  name="ship_state"
                  value={ship_state}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
              <Col sm={6}>
                <Input
                  type="text"
                  name="ship_zip"
                  value={ship_zip}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
            </Row> */}

            {/* <Row>
              <Col sm={6}>
                <label>
                  <Translate value="name" />:
                </label>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Input
                  type="text"
                  name="ship_name"
                  value={ship_name}
                  onChange={(e) => this.handleInputFieldChange(e.target)}
                />
              </Col>
            </Row> */}
  </div>
      }
            
            <Row className="centerStyle" style={{ marginTop: "0px" }}>
              <Button
                bsStyle="success"
                disabled={false}
                onClick={(e) => {
                  this.handleSubmit();
                }}
                // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
              >
                <Translate value="create" />
              </Button>
            </Row>
          </div>
        );
      }
}

export default GenerateBOLModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/generateBOLModal.jsx